<div class="page-not-found-container page-container">
  <h1 class="bold">404</h1>
  <h2>Page not found</h2>
  <button mat-raised-button class="contrast-button" [routerLink]="'/'">Homepage</button>
</div>
